import { BroadcastDeviceVideoType } from '@magnetar/data-access'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export interface BroadcastDeviceVod {
  vod_id: number
  broadcast_device_id: number
  source: string
  vod_name: string
  broadcast_type: BroadcastDeviceVideoType
  order: number | null
  created_at: Date
  is_active: boolean
  template_id?: number | null
}

interface UseVodListParams {
  broadcastDeviceId?: number
  broadcastType: BroadcastDeviceVideoType
}

export function useBroadcastDeviceVodList({ broadcastDeviceId, broadcastType }: UseVodListParams) {
  const { token } = useAuth()

  const { data, error, mutate, isLoading } = useGet<ApiResponse<BroadcastDeviceVod[]>>(
    token && broadcastDeviceId
      ? `/api/broadcast-device/${broadcastDeviceId}/vod?type=${broadcastType}`
      : null,
    undefined,
    token ?? '',
  )

  return {
    vods: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
